const getters = {
    user: state => state.user,
    imgProfile: state => state.user.data.picture,
    initials: state => {
        return state.user.data.displayName
            .split(" ")
            .map(word => word[0].toUpperCase())
            .join("");
    },
    usprivacy: state => state.user.usprivacy,
    isVisibleSaveWordPopup: state => {
        return state.saveWordPopup.visible;
    },
    getUserActions: state => {
        return state.user.actions;
    },
    getUserStarredWords: state => {
        const { actions } = state.user;
        if (actions && actions.hasOwnProperty("starred_related_words")) {
            return actions["starred_related_words"];
        }
        return [];
    },
    getUpvotedWords: state => {
        const { actions } = state.user;
        if (actions && actions.hasOwnProperty("upvoted_related_words")) {
            return actions["upvoted_related_words"];
        }
        return [];
    },
    getDownvotedWords: state => {
        const { actions } = state.user;
        if (actions && actions.hasOwnProperty("downvoted_related_words")) {
            return actions["downvoted_related_words"];
        }
        return [];
    }
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/Login/getters.js